<template>
  <div class="thai-hilo-number">
    <div class="thai-hilo-number-container" type="flex">
      <new-bet-lot
        v-for="item in doubleDigitRowOne"
        class="thai-hilo-double-digit-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :category="item"
        :key="item"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
      <new-bet-lot
        v-for="item in doubleDigitRowTwo"
        class="thai-hilo-double-digit-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :category="item"
        :key="item"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
      <new-bet-lot
        v-for="item in tripleDigitRow"
        class="thai-hilo-triple-digit-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :category="item"
        :key="item"
        :type="item"
        :win="winCellNo === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["winCellNo", "game", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      doubleDigitRowOne: ["o71", "o74", "o75", "o77", "o78"],
      doubleDigitRowTwo: ["o79", "o80", "o82", "o83", "o84"],
      // tripleDigitRow: ["o89", "o90", "o91", "o92"]
      tripleDigitRow: ["o85", "o86", "o87", "o88"]
    };
  }
};
</script>

<style lang="scss" scoped>
.thai-hilo-number {
  width: 100%;
  position: relative;
}

.thai-hilo-double-digit-betlot {
  width: 20%;
  display: inline-block;
  border: 1px solid white;
}

.thai-hilo-triple-digit-betlot {
  width: 25%;
  display: inline-block;
  border: 1px solid white;
}

.thai-hilo-number-betlot:first-of-type {
  margin-left: unset;
}

.thai-hilo-number-betlot:last-of-type {
  margin-right: unset;
}
</style>